import { combineEpics } from 'redux-observable';
import { articlesEpic } from '../article/ArticlesEpic';
import { menuEpic } from '../menu/MenuEpic';

export const rootEpic = combineEpics(
    menuEpic,
    articlesEpic,
);



// WEBPACK FOOTER //
// ./src/store/RootEpic.ts